import {
  FETCH_TRANS,
  FETCH_FIXTURES,
  FETCH_USER_PLAYED_GAMEDAYS,
  CHANGE_SELECTED_FIXTURE,
  FETCH_MTACH_QUESTIONS,
  FETCH_MTACH_USER_ANSWER,
  POST_MTACH_USER_ANSWER,
  POST_MTACH_USER_BOOSTER,
  SET_DATA_AFTER_POST,
  FETCH_MTACH_USER_POINTS,
  SET_DATA_ALERT,
  FETCH_CONTRAINTS,
  FETCH_MIX,
  CLEAR_DATA_QUESTIONS,
  FETCH_LEADERBOARD,
  FETCH_LEADERBOARD_RANK,
  SET_WRAPPER_REF,
  POST_CREATE_LEAGUE,
  POST_JOIN_LEAGUE,
  POST_APPLY_JOKER,
  FETCH_USER_LEAGUES,
  POST_LOGIN,
  UPDATE_QUESTION_STATUS,
  FETCH_BALANCE,
  FETCH_TOUR_STATUS,
} from "./../../actionTypes";

import {
  transAPI,
  fixturesAPI,
  matchQuestionsAPI,
  userPlayedGamedaysAPI,
  userAnswersAPI,
  userAnswersPostAPI,
  userBoosterPostAPI,
  usermatchrankAPI,
  constraintsAPI,
  mixAPI,
  leaderboardAPI,
  leaderboardRankAPI,
  leagueCreateAPI,
  leagueJoinAPI,
  applyJokerAPI,
  getUserLeagueAPI,
  leagueLeaderboardAPI,
  leagueLeaderboardRankAPI,
  postLoginAPI,
  getUserBalanceAPI,
  tourStatusApi,
} from "./../../apiUrls";

import objUrl from "./../../apiUrls";
import config from "./../../../common/config";
import core from "./../../../common/core";
import app from "./../../../common/app";

/** START API */
////////////////get//////////////////////
export function transFetchData() {
  let transVersion = 1.62;
  let apiUrl = transAPI;
  if (window.transVersion) {
    transVersion = window.transVersion;
  }
  apiUrl = apiUrl.replace("{{lang}}", config.CURRENT_LANGUAGE);
  apiUrl = apiUrl.replace("{{transVersion}}", transVersion);
  const params = {
    url: apiUrl,
    params: {},
  };
  return { type: FETCH_TRANS, payload: core.makeAPICall(params) };
}

// Eot starts here
export function getTourStatus() {
  let apiUrl = tourStatusApi;
  const params = {
    url: apiUrl,
    params: {},
  };
  return { type: FETCH_TOUR_STATUS, payload: core.makeAPICall(params) };
}
// Eot ends here

export function fixturesFetchData(payload) {
  const { VersionMaster, sportId } = payload || {};

  // console.log("VersionMaster :", VersionMaster);
  let params = {
    url: fixturesAPI,
    params: {
      // lang: config.CURRENT_LANGUAGE,
      // sportId: sportId ? sportId : 1,
    },
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_FIXTURES, payload: core.makeAPICall(params) };
}

//
export function questionsFetchData(payload) {
  const { VersionMaster, sportId, matchId, jMdStatus } = payload || {};

  let params = {
    url: `${matchQuestionsAPI}_${matchId}.json`,
    params: {
      // lang: config.CURRENT_LANGUAGE,
      // sportId: sportId ? sportId : 1,
      // matchId: matchId,
    },
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return {
    type: FETCH_MTACH_QUESTIONS,
    payload: core.makeAPICall(params),
    meta: { jMdStatus: jMdStatus },
  };
}
//

export function answersFetchData(payload) {
  const { VersionMaster, sportId, matchId, gamedayId } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = userAnswersAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    params: {
      optType: 1,
      lang: config.CURRENT_LANGUAGE,
      // sportId: sportId ? sportId : 1,
      matchId: matchId,
      gamedayId: gamedayId,
    },
  };
  if (VersionMaster) {
    params.params.livebuster = VersionMaster;
  }
  return { type: FETCH_MTACH_USER_ANSWER, payload: core.makeAPICall(params) };
}
export function answersPostData(payload) {
  const { gamedayId, betCoins, matchId, questionId, optionId, cancelToken } =
    payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = userAnswersPostAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    method: "POST",
    data: {
      matchId: matchId,
      questionId: questionId,
      optionId: optionId,
      tourGamedayId: gamedayId,
      betCoin: betCoins,
      platformId: config.Platform.web,
    },
  };
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return { type: POST_MTACH_USER_ANSWER, payload: core.makeAPICall(params) };
}
export function boosterPostData(payload) {
  const { sportId, matchId, questionId, boosterId } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = userBoosterPostAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    method: "POST",
    params: {
      optType: 1,
      sportId: sportId ? sportId : 1,
      matchId: matchId,
      boosterId: boosterId,
      questionId: questionId,
    },
  };
  return { type: POST_MTACH_USER_BOOSTER, payload: core.makeAPICall(params) };
}
export function createLeaguePostData(payload) {
  const { optType, leagueName, sportId } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = leagueCreateAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    method: "POST",
    data: {
      optType,
      leagueName,
      sportId,
    },
  };
  return { type: POST_CREATE_LEAGUE, payload: core.makeAPICall(params) };
}
export function joinLeaguePostData(payload) {
  const { optType, leagueCode, sportId } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = leagueJoinAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    method: "POST",
    data: {
      optType,
      leagueCode,
      sportId,
    },
  };
  return { type: POST_JOIN_LEAGUE, payload: core.makeAPICall(params) };
}

export function applyJoker(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = applyJokerAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    method: "POST",
    data: payload,
  };
  return { type: POST_APPLY_JOKER, payload: core.makeAPICall(params) };
}

export function getUserLeaguesData(payload) {
  const { VersionMaster, sportId, matchId, pageNo, topNo } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = getUserLeagueAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    method: "GET",
    params: {
      sportId: sportId ? sportId : 1,
      vPageNo: pageNo ? pageNo : 1,
      vTopNo: topNo ? topNo : 100,
    },
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_USER_LEAGUES, payload: core.makeAPICall(params) };
}
export function getUserPlayedGameDays(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = userPlayedGamedaysAPI.replace("{{guid}}", guid);
  const { sportId } = payload || {};
  const params = {
    url: sUrl,
    params: {
      // sportId: sportId ? sportId : 1,
    },
  };
  return {
    type: FETCH_USER_PLAYED_GAMEDAYS,
    payload: core.makeAPICall(params),
  };
}
export function pointsFetchData(payload) {
  const { VersionMaster, sportId, matchIds, isLive } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = usermatchrankAPI.replace("{{guid}}", guid);
  let params = {
    url: sUrl,
    params: {
      // sportId: sportId ? sportId : 1,
      // matchIds: matchIds,
      // isLive: isLive,
    },
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_MTACH_USER_POINTS, payload: core.makeAPICall(params) };
}
export function changeSelectedFixture(payload) {
  return {
    type: CHANGE_SELECTED_FIXTURE,
    payload: payload,
  };
}
export function setDataAfterPost(payload) {
  return {
    type: SET_DATA_AFTER_POST,
    payload: payload,
  };
}
export function showHideAlert(payload) {
  const { isShow, titleText, headerText, nodeButtons, sClass, fnCallback } =
    payload;
  let sClassName = "";
  if (isShow) {
    sClassName = "" + " " + sClass;
  }
  let showHideAlertT = showHideAlert;
  if (fnCallback) {
    showHideAlertT = () => {
      showHideAlert();
      fnCallback();
    };
  }

  return {
    type: SET_DATA_ALERT,
    payload: {
      propsAlert: {
        isShow: isShow,
        titleText: titleText,
        headerText: headerText,
        nodeButtons: nodeButtons,
        sClass: sClassName,
        showHideAlert: showHideAlertT,
      },
    },
  };
}
export function getContraints(payload) {
  const { sportId } = payload || {};
  const params = {
    url: constraintsAPI,
    params: {
      // sportId: sportId ? sportId : 1,
    },
  };
  return { type: FETCH_CONTRAINTS, payload: core.makeAPICall(params) };
}
export function mixFetchData(payload) {
  const { VersionMaster, sportId, isNotShowLoader, cancelToken } =
    payload || {};
  const params = {
    loader: isNotShowLoader,
    url: mixAPI,
    params: {
      // sportId: sportId ? sportId : 1,
    },
  };

  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }

  // if (cancelToken) {
  //   params.cancelToken = cancelToken;
  // }

  return { type: FETCH_MIX, payload: core.makeAPICall(params) };
}
export function leaderboardFetchData(payload) {
  const { VersionMaster, gamedayID, phaseId, optType } = payload || {};
  let sUrl = leaderboardAPI;
  let obj = {
    optType: optType,
    gamedayID: gamedayID,
    phaseId: phaseId,
  };

  let params = {
    url: sUrl,
    params: obj,
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_LEADERBOARD, payload: core.makeAPICall(params) };
}
export function leaderboardRankFetchData(payload) {
  const { VersionMaster, gamedayID, phaseId, optType } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sUrl = leaderboardRankAPI.replace("{{guid}}", guid);
  let obj = {
    optType: optType,
    gamedayID: gamedayID,
    phaseId: phaseId,
  };

  let params = {
    url: sUrl,
    params: obj,
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_LEADERBOARD_RANK, payload: core.makeAPICall(params) };
}
export function userBalanceFetchData(payload) {
  const { VersionMaster } = payload || {};
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sUrl = getUserBalanceAPI.replace("{{guid}}", guid);
  let obj = {};
  let params = {
    url: sUrl,
    params: obj,
  };
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_BALANCE, payload: core.makeAPICall(params) };
}
export function loginPost(payload) {
  const params = {
    url: postLoginAPI,
    method: "POST",
    params: {
      waf_guid: payload.guid,
    },
    //data: payload
  };
  return { type: POST_LOGIN, payload: core.makeAPICall(params) };
}

export function clearDataQuestions(payload) {
  return {
    type: CLEAR_DATA_QUESTIONS,
    payload: payload,
  };
}
export function setRef(payload) {
  return {
    type: SET_WRAPPER_REF,
    payload: payload,
  };
}
export function updateQuestionStatus(payload) {
  return {
    type: UPDATE_QUESTION_STATUS,
    payload: payload,
  };
}
